export default __webpack_public_path__ + "media/images/phone-icon-0a41e9b5ecd2f152f43591550a3f22c4.svg";